@import '../../../../../styles/above-the-fold/base/iconfont';
@import '../../../../../styles/global/global-imports';

:host {
  li {
    padding: .5rem 0;
    display: flex;
    align-items: baseline;

    a {
      @include textLink;
      color: inherit;
      font-size: $font-size-18;
      line-height: $font-size-24;
    }

    &:before {
      transform: rotate(90deg);
      display: block;
      margin-right: .5rem;
      @extend %icon;
      @extend %icon_arrow_up;
    }
  }
}

@include breakpoint(minmd) {
  :host {
    li {
      a {
        font-size: $font-size-20;
        line-height: $font-size-28;
      }
    }
  }
}
